import type {
  Company,
  CompanySetResult,
  SetCompanyOptions,
} from '@maestro/data-layer'

import { apiGet, apiPost } from '@maestro/core/api-client'

export function getCompanies(search?: string): Promise<Company[]> {
  return apiGet<Company[]>('/api/companies', { search })
}

export function setCompany(
  id?: string,
  options?: SetCompanyOptions
): Promise<CompanySetResult> {
  return apiPost<CompanySetResult>('/api/company', { id, ...options })
}
